import React from "react";
import styles from "./style.module.scss";
import PitWindowPaceTable from "../../../components/Timing/PitWindowPaceTable";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import PitBoostCorrectedLeaderboard from "../../../components/Timing/PitBoostCorrectedLeaderboard";
import TimingDataManager from "../../../components/DataManagers/TimingDataManager";
import VirtualGapsDataManager from "../../../components/DataManagers/VirtualGapsDataManager";
import AttackModeDataManager from "../../../components/DataManagers/AttackModeDataManager";
import AuthenticatedLayout from "../../../components/Layout/authenticatedLayout";
import ImportsDataManager from "../../../components/DataManagers/ImportsDataManager";
import OppositePitStrategyGraph from "../../../components/Timing/OppositePitStrategyGraph";
import { FiExternalLink } from "react-icons/fi";
import PitLossScatter from "../../../components/Timing/PitLossGraphs/PitLossScatter";
import PitLossLine from "../../../components/Timing/PitLossGraphs/PitLossLine";

function PitBoostPage() {
  const hilightedParticipant = useSelector(
    (state: RootState) => state.virtualGaps.hilightedParticipant,
  );

  const showLoops = useSelector(
    (state: RootState) => state.virtualGaps.showLoops,
  );

  return (
    <AuthenticatedLayout title={"Pit Boost"} showJaguarLogo={false}>
      <TimingDataManager />
      <ImportsDataManager />
      <VirtualGapsDataManager />
      <AttackModeDataManager />
      <div className={styles.container}>
        <div className={styles.tableColumn}>
          <PitBoostCorrectedLeaderboard />
          <button
            className={styles.pageLink}
            onClick={() => window.open("/pit-boost-leaderboard", "_blank")}
          >
            Open Compact Version <FiExternalLink />
          </button>
        </div>
        <div className={styles.rightGroup}>
          <PitWindowPaceTable />
          <div
            className={`${styles.rightColumn} ${
              showLoops ? styles.showLoops : ""
            }`}
          >
            <div
              className={`${styles.graphContainer} ${
                showLoops ? styles.showLoopsGraph : ""
              }`}
            >
              <OppositePitStrategyGraph
                referenceDriver={hilightedParticipant ?? ""}
              />
            </div>
            <div className={styles.pitLossGraphs}>
              <PitLossScatter />
              <PitLossLine />
            </div>
          </div>
        </div>
      </div>
    </AuthenticatedLayout>
  );
}

export default PitBoostPage;
